import { PROFILE_ENV } from '@/config';
import profile from '@/config/profile';
import React, { useState, useEffect } from 'react';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isLightTheme = profile?.theme === 'light';
  const [textAnimations, setTextAnimations] = useState({
    creating: false,
    great: false,
    work: false,
    since: false,
    year: false
  });

  useEffect(() => {
    setIsVisible(true);
    
    // Staggered text animations
    const delays = [
      { key: 'creating', delay: 300 },
      { key: 'great', delay: 600 },
      { key: 'work', delay: 900 },
      { key: 'since', delay: 1200 },
      { key: 'year', delay: 1500 }
    ];

    delays.forEach(({ key, delay }) => {
      setTimeout(() => {
        setTextAnimations(prev => ({ ...prev, [key]: true }));
      }, delay);
    });
  }, []);

  return (
    <section id="home" className="min-h-screen flex items-center justify-between px-8 pt-20">
      <div className="flex-1 max-w-3xl">
        <div className="hero-text">
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold leading-none">
            <div className={`transition-all duration-1000 transform ${
              textAnimations.creating ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
            }`}>
              DELIVERING
            </div>
            <div className="flex items-center gap-4">
              <span className={`transition-all duration-1000 transform ${
                textAnimations.great ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
              }`}>
                MEANINGFUL
              </span>
              <div className={`relative transition-all duration-1000 transform ${
                textAnimations.work ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
              }`}>
                <div className="absolute inset-0 bg-blue-500 rounded-full transform scale-110 animate-pulse"></div>
                <span className="relative z-10 text-white bg-blue-500 px-8 py-2 rounded-full font-bold">
                  IMPACT
                </span>
              </div>
            </div>
            <div className={`transition-all duration-1000 transform ${
              textAnimations.since ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
            }`}>
              SINCE
            </div>
            {profile?.experiences?.[profile?.experiences?.length-1]?.year 
            ? <div className={`text-blue-500 transition-all duration-1000 transform ${
              textAnimations.year ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-20 opacity-0 scale-75'
            }`}>
              {profile?.experiences?.[profile?.experiences?.length-1]?.year || new Date().getFullYear()} 
            </div>
            : null}
          </h1>
        </div>
        
        <p className={`text-sm mt-8 max-w-xs leading-relaxed transition-all duration-1000 delay-1000 transform ${
          isLightTheme ? 'text-slate-600' : 'text-gray-400'
        } ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          {profile?.keyAnalyze?.join(', ')}. Let's build a better future!
        </p>
      </div>

      <div className={`flex-1 flex justify-center items-center transition-all duration-1500 delay-500 transform ${
        isVisible ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-20 opacity-0 scale-95'
      }`}>
        <div className="relative">
          <div className="absolute inset-0 bg-blue-500 rounded-full blur-3xl opacity-20 animate-pulse"></div>
          <img
            src={`/assets/img/${PROFILE_ENV}-image.png`}
            alt="user-profile-img"
            className="relative z-10 w-80 h-96 object-cover rounded-lg shadow-2xl hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;